// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type StorageLocationId = ID<"storageLocation">;
export const storageLocationIdFormat = idFormat<StorageLocationId>({
  prefix: "sl_",
});

export type StorageLocationGroupId = ID<"storageLocationGroup">;
export const storageLocationGroupIdFormat = idFormat<StorageLocationGroupId>({
  prefix: "slg_",
});

export type StorageLocationInventoryId = ID<"storageLocationInventory">;
export const storageLocationInventoryIdFormat =
  idFormat<StorageLocationInventoryId>({ prefix: "sli_" });

export type StorageLocationTransferId = ID<"storageLocationTransfer">;
export const storageLocationTransferIdFormat =
  idFormat<StorageLocationTransferId>({ prefix: "slt_" });

export type InventoryLevelId = ID<"inventoryLevel">;
export const inventoryLevelIdFormat = idFormat<InventoryLevelId>({
  prefix: "il_",
});

export type InventoryLevelLedgerId = ID<"inventoryLevelLedger">;
export const inventoryLevelLedgerIdFormat = idFormat<InventoryLevelLedgerId>({
  prefix: "ill_",
});

export type TransferSessionId = ID<"transferSession">;
export const transferSessionIdFormat = idFormat<TransferSessionId>({
  prefix: "trs_",
});

export type BinCountSessionId = ID<"binCountSession">;
export const binCountSessionIdFormat = idFormat<BinCountSessionId>({
  prefix: "bcs_",
});

export type BinAssignmentSessionId = ID<"binAssignmentSession">;
export const binAssignmentSessionIdFormat = idFormat<BinAssignmentSessionId>({
  prefix: "bas_",
});

export type TaskId = ID<"task">;
export const taskIdFormat = idFormat<TaskId>({ prefix: "tsk_" });

export type TaskReferenceId = ID<"taskReference">;
export const taskReferenceIdFormat = idFormat<TaskReferenceId>({
  prefix: "tkr_",
});

export type TaskAssignmentId = ID<"taskAssignment">;
export const taskAssignmentIdFormat = idFormat<TaskAssignmentId>({
  prefix: "tas_",
});

export type TaskUserEventId = ID<"taskUserEvent">;
export const taskUserEventIdFormat = idFormat<TaskUserEventId>({
  prefix: "tue_",
});

export type TaskUserStateId = ID<"taskUserState">;
export const taskUserStateIdFormat = idFormat<TaskUserStateId>({
  prefix: "tus_",
});

export type ReturnsCenterId = ID<"returnsCenter">;
export const returnsCenterIdFormat = idFormat<ReturnsCenterId>({
  prefix: "rctr_",
});

export type ConsolidationScheduleId = ID<"consolidationSchedule">;
export const consolidationScheduleIdFormat = idFormat<ConsolidationScheduleId>({
  prefix: "cs_",
});

export type ConsolidationGroupId = ID<"consolidationGroup">;
export const consolidationGroupIdFormat = idFormat<ConsolidationGroupId>({
  prefix: "cg_",
});

export type ConsolidationId = ID<"consolidation">;
export const consolidationIdFormat = idFormat<ConsolidationId>({
  prefix: "con_",
});

export type ConsolidationCartonId = ID<"consolidationCarton">;
export const consolidationCartonIdFormat = idFormat<ConsolidationCartonId>({
  prefix: "cc_",
});

export type MerchantConsolidationBinId = ID<"merchantConsolidationBin">;
export const merchantConsolidationBinIdFormat =
  idFormat<MerchantConsolidationBinId>({ prefix: "mcb_" });

export type ProcessingGroupId = ID<"processingGroup">;
export const processingGroupIdFormat = idFormat<ProcessingGroupId>({
  prefix: "pg_",
});

export type SortingToteId = ID<"sortingTote">;
export const sortingToteIdFormat = idFormat<SortingToteId>({ prefix: "st_" });

export type StationProcessingSessionId = ID<"stationProcessingSession">;
export const stationProcessingSessionIdFormat =
  idFormat<StationProcessingSessionId>({ prefix: "sps_" });

export type SortDestinationId = ID<"sortDestination">;
export const sortDestinationIdFormat = idFormat<SortDestinationId>({
  prefix: "sd_",
});

export type StationProcessingSessionToteId = ID<"stationProcessingSessionTote">;
export const stationProcessingSessionToteIdFormat =
  idFormat<StationProcessingSessionToteId>({ prefix: "spst_" });

export type ToteDispositionId = ID<"toteDisposition">;
export const toteDispositionIdFormat = idFormat<ToteDispositionId>({
  prefix: "td_",
});

export type WarehouseFlaggedProblemId = ID<"warehouseFlaggedProblem">;
export const warehouseFlaggedProblemIdFormat =
  idFormat<WarehouseFlaggedProblemId>({ prefix: "wfp_" });

export type WarehouseFlaggedProblemReasonId =
  ID<"warehouseFlaggedProblemReason">;
export const warehouseFlaggedProblemReasonIdFormat =
  idFormat<WarehouseFlaggedProblemReasonId>({ prefix: "wfpr_" });

export type WarehouseItemWorkRequestId = ID<"warehouseItemWorkRequest">;
export const warehouseItemWorkRequestIdFormat =
  idFormat<WarehouseItemWorkRequestId>({ prefix: "wiwr_" });

export type PhotoInstructionsId = ID<"photoInstructions">;
export const photoInstructionsIdFormat = idFormat<PhotoInstructionsId>({
  prefix: "phin_",
});

export type PhotoInstructionStepId = ID<"photoInstructionStep">;
export const photoInstructionStepIdFormat = idFormat<PhotoInstructionStepId>({
  prefix: "phis_",
});

export type WarehouseItemPhotoCaptureId = ID<"warehouseItemPhotoCapture">;
export const warehouseItemPhotoCaptureIdFormat =
  idFormat<WarehouseItemPhotoCaptureId>({ prefix: "ipc_" });
